import { useState } from "react";
import OrangeButton from "../../../../components/buttons/OrangeButton";
import ModalComponent from "../../../../components/modals/ModalFormComponent";
import { TIME_REQUEST_LABELS, TimeRequestKind } from "../data";
import { useTimeRequestMutations } from "../useTimeRequestApi";

type CancelTimeRequestModalProps = {
	kind: TimeRequestKind;
	request: any;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	onCancelled: () => void;
};

const CancelTimeRequestModal = ({
	kind,
	request,
	open,
	setOpen,
	onCancelled,
}: CancelTimeRequestModalProps) => {
	const [cancelling, setCancelling] = useState(false);
	const { cancel } = useTimeRequestMutations(kind);

	const handleCancel = () => {
		setCancelling(true);
		cancel.mutate(
			{ id: request.id },
			{
				onSuccess: () => {
					onCancelled();
					setOpen(false);
				},
				onSettled: () => setCancelling(false),
			},
		);
	};

	return (
		<ModalComponent
			width={560}
			open={open}
			title={`Cancel ${TIME_REQUEST_LABELS[kind].name}`}
			handleClose={() => setOpen(false)}
		>
			<p className="text-2sm text-gray-600">
				The request will no longer be sent for approval. You can submit a new one
				afterwards.
			</p>
			<div className="w-full flex justify-end mt-8">
				<OrangeButton
					title={cancelling ? "Cancelling..." : "Cancel Request"}
					className="px-8"
					disabled={cancelling}
					onClick={handleCancel}
				/>
			</div>
		</ModalComponent>
	);
};

export default CancelTimeRequestModal;
